jQuery(function($) {
    // Vars //
    var $html = $('html'); 
    var $body = $('body');
    var $window = $(window);
    var $header = $('header');

    // Functions
    back_to_top();
    header_hero_slider();
    logo_section_slider();
    inner_block_image_slider();
    testimonial_block_slider();
    content_slider();

    /**
     * 
     * Gravity Form Select Options
     * 
     */
    // Name Field - Prefix
    styled_select_2('.name_prefix_select select');

    // Dropdown
    styled_select_2('.ginput_container_select select');

    // Time Field - AM/PM Dropdown
    styled_select_2('.ginput_container_time select');

    // Address Field - Country Dropdown
    styled_select_2('.ginput_address_country select');
    // Gravity Form Select Options -- END

    // Onclick Events
    $body
        .on('click', '.scroll-to-top', function (e) {
            e.preventDefault();
            var $trigger = $(this);

            $("html, body").animate({ scrollTop: 0 }, 1500);
            return false;
        })
        .on('click', '.js-mobile-trigger', function (e) {
            e.preventDefault();
            var $trigger = $(this);
            // changed to apply class to all mobile triggers so I can have multiple on page
            var $mobileTriggers = $('.js-mobile-trigger');
            if ($mobileTriggers.hasClass('active')) {
                $mobileTriggers.removeClass('active');
                $body.removeClass('hamburger-menu-active');
                $html.removeClass('no-scroll');
                $body.removeClass('no-scroll');
            }
            else {
                $mobileTriggers.addClass('active');
                $body.addClass('hamburger-menu-active');
                $html.addClass('no-scroll');
                $body.addClass('no-scroll');
            }
        })
        .on('click', '.js-footer-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.footer-accordion');
            var $accordionContent = $accordion.find('.footer-accordion__content');
            if ($accordion.hasClass('active')) {
                $accordion.removeClass('active');
                $accordionContent.slideUp(350);
            } else {
                $accordion.addClass('active');
                $accordionContent.slideDown(350);
            }
        })
        .on('click', '.js-accordion-trigger', function (e) {
            e.preventDefault();
            var $accordion = $(this).closest('.accordion');
            var $accordionContent = jQuery($accordion).find('.accordion__content');
            if ($accordion.hasClass('open')) {
                $accordion.removeClass('open');
                $accordionContent.slideUp();
            } else {
                $accordion.addClass('open');
                $accordionContent.slideDown();
            }
        })
        .on('click', '.menu-item-dropdown-toggle', function(e) {
            e.preventDefault();
            var $trigger = $(this);
            $navItem = $trigger.closest('.nav-list__item');
            $navItem.addClass('active-dropdown');
        })
        .on('click', '.dropdown-back-btn', function(e) {
            e.preventDefault();
            var $trigger = $(this);
            $navInner = $trigger.closest('.primary-navigation__mobile-navigation--inner');
            $navItem  = $trigger.closest('.nav-list__item');
            $navInner.removeClass('active');
            $navItem.removeClass('active-dropdown');
        })
    ;

    // Resize Functions //
    var resizeThreshold;
    $(window).on('resize', function () {
        if (resizeThreshold) {
            clearTimeout(resizeThreshold);
        }

        resizeThreshold = setTimeout(function () {
            setTimeout(function () {
                // Functions
            }, 100);
        }, 200);
    });





    // header search
    var $headerSearch = $('.header-search');
    $headerSearch.find('.btn.mobile-search-trigger').on('click', function(e) {
        if(!$headerSearch.hasClass('show')) {
            e.preventDefault();
            $headerSearch.addClass('show');
            $headerSearch.find('input').focus();
            $headerSearch.find('input').on('focusout', function(e) {
                setTimeout(function() {
                    $headerSearch.removeClass('show');

                },250);
            })
        }
    })
});

